import { gql } from '@apollo/client';
import { partnerConsentFragment } from './fragments';

export const CONSENT_PARTNER_TYPES = gql`
  query consentPartnerTypes($id: Int!) {
    consentPartnerTypes(id: $id)
  }
`;

export const PARTNER_CONSENTS = gql`
  query partnerConsents {
    partnerConsents {
      ...partnerConsent
    }
  }
  ${partnerConsentFragment}
`;

export const PARTNER_CONSENT_TEMPLATES = gql`
  query partnerConsentTemplates {
    partnerConsentTemplates {
      id
      name
    }
  }
`;

export const ALLOWED_PARTNER_TYPES = gql`
  query allowedPartnerTypes {
    allowedPartnerTypes {
      id
      code
      name
    }
  }
`;
